import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import Picture from "/components/core/picture/picture-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { INDUSTRIES_CONFIG } from "services/industries/industries-service";
import { componentStyles } from "./industry-selection-second-step.scss";
class IndustrySelectionSecondStepComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "industry-selection-second-step-wrapper",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "done-gif-wrapper",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/static/img/industry-selection/done.gif",
                        className: `jsx-${componentStyles.__hash}`
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "signup-title",
                    children: " That’s awesome!"
                }),
                /*#__PURE__*/ _jsx("div", {
                    dangerouslySetInnerHTML: {
                        __html: INDUSTRIES_CONFIG.signupHtmlSubTitle
                    },
                    className: `jsx-${componentStyles.__hash}` + " " + "signup-subtitle"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "signup-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, {})
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { IndustrySelectionSecondStepComponent as default };
